import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
// eslint-disable-next-line max-classes-per-file -- directive added automatically by Shepherd migration
import React from 'react';
import PropTypes from 'prop-types';
import goToAnchor from './go-to-anchor'; // this module uses two Contexts internally.
// the first Context is to provide a default consumer handler
// and to allow that default to be overridden from above

var AnchorContext = /*#__PURE__*/React.createContext({
  onAnchorClick: goToAnchor
}); // the second Context is to hold on to the bound handlers
// and provide them to consumers of this modules Context

var AnchorHandlersContext = /*#__PURE__*/React.createContext({
  handleTargetRef: function handleTargetRef() {},
  handleAnchorClick: function handleAnchorClick() {},
  // Provides a means for components to get the ref of a given anchor link target.
  // Used within TableOfContents, for example.
  getTargetRef: function getTargetRef() {}
});

var AnchorContextProviderImpl = /*#__PURE__*/function (_React$Component) {
  _inherits(AnchorContextProviderImpl, _React$Component);

  var _super = _createSuper(AnchorContextProviderImpl);

  function AnchorContextProviderImpl(props) {
    var _this;

    _classCallCheck(this, AnchorContextProviderImpl);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getTargetRef", function (target) {
      return _this.props.targetMap.get(target);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTargetRef", function (ref, target) {
      if (!process.browser) return;
      var targetMap = _this.props.targetMap;
      if (!ref) return targetMap.delete(target); // don't overwrite current targets

      if (targetMap.get(target)) return; // store the target

      targetMap.set(target, ref);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAnchorClick", function (_ref, e) {
      var target = _ref.target,
          behavior = _ref.behavior;
      var onAnchorClick = _this.props.onAnchorClick;
      if (!onAnchorClick) return;
      var targetMap = _this.props.targetMap;
      var ref = targetMap.get(target);
      if (!ref) return;
      e === null || e === void 0 ? void 0 : e.preventDefault();
      onAnchorClick({
        target: target,
        elem: ref,
        behavior: behavior
      });
    });

    var _assertThisInitialize = _assertThisInitialized(_this),
        handleTargetRef = _assertThisInitialize.handleTargetRef,
        handleAnchorClick = _assertThisInitialize.handleAnchorClick,
        getTargetRef = _assertThisInitialize.getTargetRef;

    _this.state = {
      anchorHandlersContextValue: {
        onTargetRef: handleTargetRef,
        onAnchorClick: handleAnchorClick,
        getTargetRef: getTargetRef
      }
    };
    return _this;
  }

  _createClass(AnchorContextProviderImpl, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          anchorContextValue = _this$state.anchorContextValue,
          anchorHandlersContextValue = _this$state.anchorHandlersContextValue; // first re-provide the `onAnchorClick` handler to child contexts
      // then provide the handlers that used `onAnchorClick`
      // bound to this instance's ref Map()

      return /*#__PURE__*/React.createElement(AnchorContext.Provider, {
        value: anchorContextValue
      }, /*#__PURE__*/React.createElement(AnchorHandlersContext.Provider, {
        value: anchorHandlersContextValue
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var onAnchorClick = nextProps.onAnchorClick,
          targetMap = nextProps.targetMap;
      var _prevState$prevProps = prevState.prevProps,
          prevProps = _prevState$prevProps === void 0 ? {} : _prevState$prevProps;

      if (onAnchorClick === prevProps.onAnchorClick && targetMap === prevProps.targetMap) {
        return null;
      }

      return {
        prevProps: nextProps,
        anchorContextValue: {
          onAnchorClick: onAnchorClick,
          targetMap: targetMap
        }
      };
    }
  }]);

  return AnchorContextProviderImpl;
}(React.Component);
/**
 * Provides a context to [`AnchorLink`](./AnchorLink.md) and [`AnchorLinkContext`](./AnchorLinkContext.md). It's mandatory
 * to wrap this component around any uses of those components in a document.
 */


_defineProperty(AnchorContextProviderImpl, "propTypes", {
  children: PropTypes.node.isRequired,
  onAnchorClick: PropTypes.func.isRequired,
  targetMap: PropTypes.instanceOf(Map).isRequired
});

var AnchorContextProvider = /*#__PURE__*/function (_React$Component2) {
  _inherits(AnchorContextProvider, _React$Component2);

  var _super2 = _createSuper(AnchorContextProvider);

  function AnchorContextProvider(props) {
    var _this2;

    _classCallCheck(this, AnchorContextProvider);

    _this2 = _super2.call(this, props); // create a new targetMap to supply child context consumers
    // when targetMap doesn't exist in current context

    _this2.targetMap = new Map();
    return _this2;
  }

  _createClass(AnchorContextProvider, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          onAnchorClick = _this$props.onAnchorClick,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(AnchorContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(AnchorContextProviderImpl // use default `onAnchorClick` from context if prop not defined
        , {
          onAnchorClick: onAnchorClick || ctx.onAnchorClick // supply targetMap from context if present,
          ,
          targetMap: ctx.targetMap || _this3.targetMap
        }, children);
      });
    }
  }]);

  return AnchorContextProvider;
}(React.Component);

_defineProperty(AnchorContextProvider, "propTypes", {
  children: PropTypes.node.isRequired,
  onAnchorClick: PropTypes.func // eslint-disable-line react/require-default-props

});

_defineProperty(AnchorContextProvider, "defaultProps", {});

export { AnchorContextProvider };
export default AnchorHandlersContext;